import React from 'react';

import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import animator from '../../../../helpers/animator';
import UserAvatar from '../../../../components/UserAvatar';
import Animate from '../../../../components/Animate';
import dataModel from '../../../../models/DataModel';
import './ShowProjectMemberInfoPopup.scss';

export class ShowProjectMemberInfoPopup extends BaseComponent {
  constructor(props) {
    super(props);
    this.animated = false;
    this.animator = new animator();
    this.state = {
      animateClose: null,
    };
  }

  animateMe() {
    this.animated = true;
    const _this = this;
    setTimeout(() => {
      const ani = _this.animator.createPropertyAnimation(
        'show-project-member-popup' + this.props.user.id,
        300,
        {
          opacity: { startVal: 0, endVal: 1 },
        }
      );
      _this.animator.addAnimation(ani);
      _this.animator.processAnimationQueue();
    }, 10);
  }

  handleClose(noAnimation) {
    this.setState({ animateClose: true });
  }

  handleSelection(type, option) {
    dataModel.usersDAO.getUser(option.user.id, { recordDescriptor: { user: { additionalFields: ['profile_image'], role: {}, companies: {} } } }).then(user => {
      this.setState({ selectedUser: user, currentAssignmentType: null });
    });
  }

  handleKeyDown(e) {
    if (e.keyCode == 27) {
      e.preventDefault();
      this.handleClose();
    }
  }

  handleAnimateOut() {
    if (this.props.handlePopupClose) {
      this.props.handlePopupClose();
    }
  }

  handleBackgroundClicked() {
    this.handleClose();
  }

  render() {
    let { left, right, top, user, isBuildOwner } = this.props;

    if (!this.animated) {
      this.animateMe();
    }
    let style = {};
    if (left) {
      style = { top: top, left: left };
    } else {
      style = { top: top, right: right };
    }

    let userName = user.name;
    let userCompany = '';
    if (user.companies) {
      userCompany = user.companies[0].name;
    }
    let userTitle = user.title;

    let animateHeight;
    isBuildOwner ? animateHeight = 205 : userTitle ? animateHeight = 148 : animateHeight = 130;

    return (
      <div
        className={`show-project-member-background show-project-member-background--${
          this.state.animateClose ? 'closed' : 'open'
        }`}
        onClick={this.handleBackgroundClicked}
      >
        <div
          id={'show-project-member-popup'}
          className={'show-project-member-popup'}
          style={style}
          onKeyDown={this.handleKeyDown}
        >
          <Animate
            key="animate_popup-in"
            component_id={'show-project-member-popup'}
            duration={500}
            property={{ height: { startVal: 0, endVal: animateHeight } }}
          />
          {this.state.animateClose && (
            <Animate
              key="animate_popup-out"
              component_id={'show-project-member-popup'}
              duration={500}
              property={{ height: { startVal: animateHeight, endVal: 0 } }}
              completionCallback={this.handleAnimateOut}
            />
          )}
          <div className="close-button" onClick={this.handleClose} />
          <div className="user-description">
            <div className="avatar-container">
              <UserAvatar user={this.props.user} />
            </div>
            <div className="user-name">{userName}</div>
            <div className="user-title">{userTitle}</div>
            <div className="user-company">{userCompany}</div>
          </div>
          { 
            this.props.isBuildOwner && 
            <p className="build-owner-assign">View a list of tasks you manage in order to assign this user.</p>
          }
        </div>
      </div>
    );
  }
}

// Change to appropriate class name

const mapStateToProps = (state, ownProps) => {
  return {
    users: state.new_users.users,
    permissions: state.new_users.permissions,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(
  ShowProjectMemberInfoPopup
);



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectCRUD/ShowProjectMemberInfoPopup/index.js